import React, { useState, useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'
import { isLoggedIn } from 'application/services/authenticationService'
import LoginOptionForm from './loginOptionForm'
import EnterCodeForm from './enterCodeForm'
import { useHistory } from 'react-router-dom'
import { updateForProposalViewFromEmail } from 'application/actions/emailActions'
import { clearApplicationStorage } from 'application/helpers'
import { loginPageRequest } from 'application/actions/authenticationActions'
import { Icon } from 'RemServ/icons'
import * as E from './loginElements'
import { Image as RemServImage } from 'RemServ/images'

const Login = ({ isGov }) => {
  const [changedOption, updateChangedOption] = useState(false)
  const [canEnterCode, setCanEnterCode] = useState(false)
  const [option, setOption] = useState('mobile')

  const handleOptionChange = (event) => {
    setOption(event.target.value)
    updateChangedOption(true)
  }
  const history = useHistory()
  const dispatch = useDispatch()

  useEffect(() => {
    if (isLoggedIn()) {
      if (
        window.confirm('This action will cause you to be logged out.') == false
      ) {
        dispatch(loginPageRequest())
        history.push('/home')   
      } else {
        // Resets and clears all the application storage
        dispatch(loginPageRequest())
        clearApplicationStorage()
        window.location.reload()
      }
    }
    let url = window.location.href.toLowerCase()
    if (url.indexOf('&viewproposal=true') !== -1) {
      dispatch(updateForProposalViewFromEmail())
    }
  }, [])

  const MaxxiaHeader = ({}) => (
    <div>
      <E.MaxxiaLogoContainer>
        <E.MaxxiaLogo imageName="LogoWhite" />
      </E.MaxxiaLogoContainer>

      <E.MaxxiaBGLogin>
        <div className="bg-login__overlay"></div>
        <div className="bg-login__box"></div>
      </E.MaxxiaBGLogin>
    </div>
  )

  const CommonContainer = ({ canEnterCode, option, changedOption }) => (
    <E.CommonContainer className="shadow-sm">
      {!canEnterCode && (
        <LoginOptionForm
          setCanEnterCode={setCanEnterCode}
          handleOptionChange={handleOptionChange}
          option={option}
          changedOption={changedOption}
          updateChangedOption={updateChangedOption}
        />
      )}
      {canEnterCode && (
        <EnterCodeForm setCanEnterCode={setCanEnterCode} option={option} />
      )}
    </E.CommonContainer>
  )

  return (
    <>
      <div id="page">
        {global.config.brand === 'Maxxia' && (
          <>
            <MaxxiaHeader />
            <CommonContainer
              canEnterCode={canEnterCode}
              option={option}
              changedOption={changedOption}
            />
          </>
        )}
        {global.config.brand === 'RemServ' && (
          <E.RemServContainer>
            <RemServImage imageName="BannerImageRemserv" />

            <E.RemServImageContainer>
              {!isGov ? (
                <Icon iconType="remservWhiteLogo" size={2} />
              ) : (
                <Icon iconType="remservLeasingWhiteLogo" size={3} />
              )}
              <CommonContainer
                canEnterCode={canEnterCode}
                option={option}
                changedOption={changedOption}
              />
            </E.RemServImageContainer>
          </E.RemServContainer>
        )}
      </div>
    </>
  )
}

function mapStateToProps(state) {
  return {
    isAuthenticated: state.authentication.isAuthenticated,
    isGov: state.user.isGov,
  }
}

export default connect(mapStateToProps)(Login)
